export default "__VITE_ASSET__Bkq_sqvL__"